"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VehicleExpirationType;
(function (VehicleExpirationType) {
    VehicleExpirationType["COMPREHENSIVE_COVER"] = "COMPREHENSIVE_COVER";
    VehicleExpirationType["FIRST_AID_KIT"] = "FIRST_AID_KIT";
    VehicleExpirationType["VEHICLE_INSPECTION"] = "VEHICLE_INSPECTION";
    VehicleExpirationType["VEHICLE_INSURANCE"] = "VEHICLE_INSURANCE";
    VehicleExpirationType["VEHICLE_REGISTRATION_CERTIFICATE"] = "VEHICLE_REGISTRATION_CERTIFICATE";
    VehicleExpirationType["OTHER"] = "OTHER";
})(VehicleExpirationType || (VehicleExpirationType = {}));
exports.default = VehicleExpirationType;
